import axios from 'axios';
import { Message, Loading } from 'element-ui';
import { Base64 } from 'js-base64';
import Cookies from 'js-cookie';
import router from '@/router';
// import Auth from '../utils/auth.js';

// import { showFullScreenLoading, tryHideFullScreenLoading } from '_u/loading'

const base64token = Base64.encode('token');
// const auth = new Auth();
/**
 * 提示消息
 * @param {string} text 提示信息
 * @param {string} key 默认提示类型，根据不同组件传入对象key
 * @param {object} com 组件，从不同组件库导入不同的组件，如iview、element-ui的Message组件，vant的Taost组件
 */
const msg = (text, key = 'error', com = Message) => {
  com[key](text);
};

axios.defaults.timeout = 30 * 1000;

// 环境的切换
if (process.env.NODE_ENV === 'development') {
  axios.defaults.baseURL = '';
} else if (process.env.NODE_ENV === 'production') {
  axios.defaults.baseURL = '';
}

// 请求拦截
axios.interceptors.request.use(
  (config) => {
    console.log();
    const token = Cookies.get(base64token);
    token && (config.headers.Authorization = 'Bearer ' + token);

    if (!config.hideLoading) {
      loading;
      // showFullScreenLoading()
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

let typeStr = '';
let loading = Loading.service({
  fullscreen: true,
  background: 'rgba(0, 0, 0, 0.4)',
});

// 响应拦截
axios.interceptors.response.use(
  (response) => {
    // let title=router.currentRoute.meta.title
    // showLoading
    let { tipShow, method, hideLoading } = response.config;
    if (tipShow === undefined || tipShow) {
      if (method == 'post') {
        // typeStr = '新增';
        typeStr = '操作';
      } else if (method == 'put') {
        typeStr = '修改';
      } else if (method == 'delete') {
        typeStr = '删除';
      }
      // 不提示记录日记
      if (response.data.status !== 'ok') {
        // setTimeout(() => {
        //   !hideLoading ? loading.close() : '';
        // }, 100)
        if (
          response.config.method !== 'get' &&
          !response.config.url.includes('/api/aimanager/v1/op-log') &&
          response.config.showMsg !== false
        ) {
          Message.success(`${typeStr}成功`);
        }
      }
    }

    if (!hideLoading) {
      loading.close();
      // tryHideFullScreenLoading()
    }

    return response;
  },
  (error) => {
    loading.close();
    if (error && error.response) {
      // let errprData = error.response.data;
      switch (error.response.status) {
        case 400:
          if (error.response.data.message.includes(': ')) {
            let str = error.response.data.message.split(': ')[1];
            msg(str);
          } else if (error.response.data.message) {
            msg(error.response.data.message);
          } else {
            msg('请求错误，请检查操作是否有误');
          }
          break;
        case 401:
          // 登录失败与未登录时不提示该错误
          // auth.isLogin && sessionStorage.getItem(base64token) ? Message.warning('登录失效，请重新登录！') : ''
          // auth.logout()
          //       this.isLogin = false; // 用户是否已登录
          // this.userInfo = null; // 用户信息
          // this.token = null; // token
          Cookies.remove(base64token);
          sessionStorage.clear();
          localStorage.clear();
          const tmp = window.location.hash;
          let redirect;
          if (tmp.indexOf('redirect=') >= 0) {
            redirect = tmp.split('redirect=')[1];
          } else {
            redirect = tmp.split('#/')[1];
          }
          if (redirect && redirect !== 'login') router.push(`/login?redirect=${redirect}`);
          else router.push('/login');
          console.log('退出登录');
          break;
        case 403:
          msg('拒绝访问');
          break;
        case 404:
          msg('请求地址无效');
          break;
        case 405:
          msg('请求无效');
          break;
        case 408:
          msg('请求超时');
          break;
        case 409:
          msg('资源冲突');
          break;
        case 500:
          let str = error.response.data.data;
          msg(str ? str : '服务器繁忙，请稍后重试');
          break;
        case 501:
          msg('网络未实现');
          break;
        case 502:
          msg('网络错误');
          break;
        case 503:
          msg('服务不可用');
          break;
        case 504:
          msg('网络超时');
          break;
        case 505:
          msg('http版本不支持该请求');
          break;
        default:
          msg(`连接错误${error.response.status}`);
      }
    } else {
      let msg = error.message;
      if (msg === `timeout of ${axios.defaults.timeout}ms exceeded`) {
        msg('请求超时！');
      } else {
        console.error('前端捕获未知错误：', msg);
      }
    }
    return Promise.reject(error.response);
  },
);

/** 二次封装 */
let methods = ['get', 'delete', 'head', 'options', 'post', 'put', 'patch'];
let paramsInConfig = ['get', 'delete', 'head', 'options'];

methods.forEach((method) => {
  let fn = axios[method];
  axios[method] = (url, params = {}, config = {}) => {
    if (config.loading) {
      this.$Message.loading({
        message: '数据加载中...',
        forbidClick: true,
      });
    }

    let promise = null;
    if (paramsInConfig.includes(method)) {
      config = Object.assign({}, { params }, config);
      promise = fn.call(axios, url, config);
    } else {
      promise = fn.call(axios, url, params, config);
    }

    return new Promise((resolve, reject) => {
      promise
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {
          // Message.clear();
        });
    });
  };
});

export default axios;
